module.exports = __webpack_public_path__ + "img/section1_img3.a5bc3b23.png";